var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 41C19.7757 41 19.3687 40.8314 19.0686 40.5314C18.7686 40.2313 18.6 39.8243 18.6 39.4V34.6H12.2C11.3513 34.6 10.5374 34.2629 9.93726 33.6627C9.33714 33.0626 9 32.2487 9 31.4V12.2C9 11.3513 9.33714 10.5374 9.93726 9.93726C10.5374 9.33714 11.3513 9 12.2 9H37.8C38.6487 9 39.4626 9.33714 40.0627 9.93726C40.6629 10.5374 41 11.3513 41 12.2V31.4C41 32.2487 40.6629 33.0626 40.0627 33.6627C39.4626 34.2629 38.6487 34.6 37.8 34.6H28.04L22.12 40.536C21.8 40.84 21.4 41 21 41H20.2ZM21.8 31.4V36.328L26.728 31.4H37.8V12.2H12.2V31.4H21.8ZM15.4 17H34.6V20.2H15.4V17ZM15.4 23.4H29.8V26.6H15.4V23.4Z",
    fill: "#1167ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMessage);
export default __webpack_public_path__ + "static/media/info_message.94b3778cd5f839e4ee84580e91bc35b6.svg";
export { ForwardRef as ReactComponent };